module.exports = __webpack_public_path__ + "static/media/vodafone.1f5075da.png";